import { render, staticRenderFns } from "./LmPassword.vue?vue&type=template&id=3ada45a6&scoped=true&"
import script from "./LmPassword.vue?vue&type=script&lang=js&"
export * from "./LmPassword.vue?vue&type=script&lang=js&"
import style0 from "./LmPassword.vue?vue&type=style&index=0&id=3ada45a6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada45a6",
  null
  
)

export default component.exports